import React, { useEffect ,useState } from "react";
import Home from "./views/home.js";

import Loader from "./components/loader/loader.js";
import Vision from "./components/vision/Vision.js";
import About from "./components/about/About.js";
import Team from "./components/Team/Team.js";
import GetInvolved from "./components/Involved/Involved.js";
import Contact from "./components/Contact/Contact.js";
import Gallery from "./components/Gallery/Gallery.js";
import Donate from "./components/Donate/Donate.js";
import Events from "./components/Events/Events.js";
import {BrowserRouter,Route,Routes,Redirect,useLocation} from "react-router-dom";
import "./index.css";
import Head from "./components/Header/Head.js";
function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500); 

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
   
   <div>
      {loading ? <Loader /> : 
     
      <BrowserRouter basename="/">
        <Head />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="Vision" element={<Vision />} />
          <Route path="About" element={<About />} />
          <Route path="GetInvolved" element={<GetInvolved />} />
          <Route path="Team" element={<Team />} />
          <Route path="Contact" element={<Contact />} />
          <Route path="Gallery" element={<Gallery />} />
          <Route path="Donate" element={<Donate />} />
          <Route path="Events" element={<Events />} />
          
         
        </Routes>
      </BrowserRouter>
       }
    </div>
    </>
  );
}


export default App;
